import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { parseApiInstant } from '../util/parse-api-instant';

@Component({
    selector: 'app-email-history',
    templateUrl: './email-history.component.html',
    styleUrls: ['./email-history.component.scss'],
    standalone: false,
    providers: [DatePipe]
})
export class EmailHistoryComponent implements OnInit {

  @Input() dataEmailHistory;

  constructor(private datePipe: DatePipe) { }

  ngOnInit() {
  }

  formatDate(date: string | Date | null | undefined): string {
    const d = parseApiInstant(date);
    if (!d) {
      return 'Sin Fecha';
    }
    return this.datePipe.transform(d, 'MMM d, y h:mm a', undefined, 'en-US') ?? 'Sin Fecha';
  }

}
